import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  pt: '10px'
};

export const addToTalentListDrawerSx = {
  container
};
